import React from 'react';
import { connect } from 'react-redux';
import { Layout } from 'components';
import * as rdd from 'react-device-detect';
import { axius, func } from 'helpers';
import { Button, Form, Input, Modal } from 'antd';

const Home = (props) => {

  const [form] = Form.useForm();

  const [loading, setLoading] = React.useState(false);
  const [isMobile, setIsMobile] = React.useState(false);

  React.useEffect(() => {
    setIsMobile(rdd.isMobile);
  }, []);

  const submit = (v) => {
    setLoading(true);
    v.code = v.code.trim().toUpperCase();
    Promise.all([
      axius.get(`awards/${v.code}`),
      axius.get(`nominees/${v.code}`),
    ]).then(res => {
      if (res[0].status === 200) {
        const awd = res[0].data;
        func.redirect(`/a/${awd.slug}.${awd.id}`);
      } else if (res[1].status === 200) {
        const nom = res[1].data;
        const ctg = nom.categories.find(c => c.code === v.code);
        func.redirect(`/n/${ctg.slug}.${ctg.id}/${nom.slug}.${nom.id}`);
      } else {
        Modal.info({
          content: `You entered an invalid code.`,
          centered: true,
        });
        setLoading(false);
      }
    });
  }

  return (
    <React.Fragment>
      <Layout
        Head={{}}
      >
        <div className={`featured-1 ${isMobile ? 'py-4' : 'p-0'}`}
          styles="background-image: url('https://www.entplusgh.com/wp-content/uploads/2021/06/ki.jpg'); background-size: cover; background-position: center;">
          <div className="container">
            <div className="row">
              <div className={`col-lg-6 align-self-center ${isMobile ? 'text-center' : ''}`}>
                <p className="text-muted">
                  <span className="typewrite d-inline" data-period="2000"
                    data-type="[ &quot; Online Voting. &quot;, &quot;e-Voting. &quot;, &quot;Social Media Votes &quot; ]">
                    {/* <!-- <span class="wrap">Travel Blog</span> --> */}
                  </span>
                </p>
                <h2 className="text-whites mb-2">{func.intl('Index.Header.Your', 'Your')} <span>{func.intl('Index.Header.360', '360°')}</span> </h2>
                <h3 className="mb-20 text-whites">{func.intl('Index.Header.Platform', 'e-voting platform')}</h3>
                <h5 className="text-muted">
                  {func.intl('Index.Header.Everything', 'Everything you need to organise your next award.')}
                </h5>
              </div>
              <div className="col-lg-6 text-right d-none d-lg-block mb-40">
                <img src="assets/img/nominees.svg" alt="FayaVotes" style={{ height: 360 }} />
              </div>
            </div>
          </div>
        </div>

        <main>
          <div className="container mt-50">
            <Form form={form} onFinish={submit}>
              <div className="flex justify-center">
                <div className="w-10/12 xl:w-4/12 mr-2">
                  <Form.Item
                    name="code"
                    label={null}
                    rules={[{ required: true, message: func.intl('Alert.Required', 'This field is required!'), },]}
                  >
                    <Input
                      type="text" size="large" autoComplete="off"
                      placeholder={func.intl('Label.AwardOrNomineeCode', 'Award or nominee code to proceed to vote')}
                      disabled={loading} className="h-[40px]"
                    />
                  </Form.Item>
                </div>
                <Button size="large" type="primary" htmlType="submit" className="text-[14px]" loading={loading}>
                  Proceed
                </Button>
              </div>
            </Form>
          </div>
        </main>
      </Layout>
    </React.Fragment>
  )
}


export async function getServerSideProps(ctx) {
  const res = { data: [] };
  return {
    props: { data: res.data || [] },
  }
};

const mapStateToProps = (state) => ({
  _data: state.data,
});

export default connect(mapStateToProps, {})(Home);